import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './header-banner-video.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
var HeaderBannerVideo = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderBannerVideo, _super);
    function HeaderBannerVideo(element) {
        var _this = _super.call(this, element) || this;
        _this.windowWidth = 1200;
        _this.windowHeight = 365;
        _this.bannerRatio = _this.windowWidth / _this.windowHeight;
        _this.playerRatio = 854 / 480;
        return _this;
    }
    HeaderBannerVideo.prototype.init = function () {
        this.banner = this.element;
        this.header = this.element.querySelector('.header-banner-video__header');
        this.headerBackground = this.element.querySelector('.header-banner-video__header-background');
        this.imageHolder = this.element.querySelector('.header-banner-video__image-holder');
        this.playerContainer = this.element.querySelector('.header-banner-video__player-container');
        this.playerContent = this.element.querySelector('.header-banner-video__player-content');
        this.player = this.playerContainer.querySelector('.ot-video-containingBlock');
        this.video = this.element.querySelector('video');
        this.playButton = this.element.querySelector('.js-open-banner-video');
        this.closeButton = this.element.querySelector('.js-close-banner-video');
    };
    HeaderBannerVideo.prototype.bindEvents = function () {
        window.addEventListener('resize', this.onResize.bind(this));
        window.addEventListener('orientationchange', this.onResize.bind(this));
        setTimeout(this.onResize.bind(this));
        setTimeout(this.checkVideoPlayer.bind(this), 200);
        this.playButton.addEventListener('click', this.showVideo.bind(this));
        this.closeButton.addEventListener('click', this.hideVideo.bind(this));
    };
    HeaderBannerVideo.prototype.onResize = function () {
        this.banner.style.opacity = '1';
        this.setHeaderBackgroundDimensions();
        this.setVideoPlayerDimensions();
    };
    HeaderBannerVideo.prototype.checkVideoPlayer = function () {
        if (this.player === null) {
            setTimeout(this.checkVideoPlayer.bind(this), 200);
        }
        else {
            this.playerContainer.style.opacity = '1';
            this.playerContainer.style.visibility = 'visible';
            this.playerContainer.style.display = 'none';
        }
    };
    HeaderBannerVideo.prototype.showVideo = function (event) {
        if (event.currentTarget.hasAttribute('data-youtube-id')) {
            this.isExternal = true;
            var videoExternal = event.currentTarget;
            this.element.classList.add('video-playing');
            var getVideo = videoExternal.getAttribute('data-youtube-id');
            this.createIframePlayer(getVideo);
            this.analyticsService.dtmVideoTrackerAutoSpot();
        }
        else if (event.currentTarget.hasAttribute('data-video-file')) {
            this.isExternal = true;
            var videoExternal = event.currentTarget;
            this.element.classList.add('video-playing');
            var getVideo = videoExternal.getAttribute('data-video-file');
            this.createHTML5Player(getVideo);
        }
        else {
            this.element.classList.add('video-playing');
            this.video.player.play();
        }
    };
    HeaderBannerVideo.prototype.hideVideo = function (event) {
        event.preventDefault;
        var removeIframe = this.playerContent.querySelector('iframe');
        if (removeIframe) {
            this.playerContent.removeChild(removeIframe);
        }
        this.element.classList.remove('video-playing');
        this.video.player.pause();
    };
    HeaderBannerVideo.prototype.setHeaderBackgroundDimensions = function () {
        this.headerBackground.style.height = this.header.clientHeight + "px";
    };
    HeaderBannerVideo.prototype.setVideoPlayerDimensions = function () {
        if (MediaQueryService.getMediaQuery() !== 'small' && MediaQueryService.getMediaQuery() !== 'x-small') {
            var playerContainerHeight = this.windowWidth / this.bannerRatio;
            var playerContentWidth = playerContainerHeight * this.playerRatio;
            this.imageHolder.style.height = this.banner.clientHeight + "px";
            this.playerContainer.style.height = playerContainerHeight + "px";
            this.playerContent.style.maxWidth = playerContentWidth + "px";
        }
        else {
            var bannerHeight = this.imageHolder.querySelector("img").offsetHeight;
            var playerContainerHeight = bannerHeight + this.header.offsetHeight;
            var playerContentWidth = playerContainerHeight * this.playerRatio;
            this.imageHolder.style.height = bannerHeight + "px";
            this.playerContainer.style.height = playerContainerHeight + "px";
            this.playerContent.style.maxWidth = playerContentWidth + "px";
        }
    };
    HeaderBannerVideo.prototype.createIframePlayer = function (url) {
        this.playerContent.style.height = '100%';
        this.playerContainer.style.opacity = '1';
        this.playerContainer.style.visibility = 'visible';
        this.playerContainer.style.display = 'none';
        this.playerContainer.style.height = '100%';
        var externalUrl = 'https://www.youtube.com/embed/';
        externalUrl += url;
        externalUrl += '?rel=0&amp;showinfo=0&autoplay=1&enablejsapi=1';
        var createIframe = document.createElement('iframe');
        createIframe.id = 'video__external';
        createIframe.src = externalUrl;
        createIframe.classList.add('video__iframe');
        this.playerContent.appendChild(createIframe);
        this.analyticsService.dtmVideoTrackerAutoSpot();
    };
    HeaderBannerVideo.prototype.createHTML5Player = function (url) {
        this.playerContent.style.height = '100%';
        this.playerContainer.style.opacity = '1';
        this.playerContainer.style.visibility = 'visible';
        this.playerContainer.style.display = 'none';
        this.playerContainer.style.height = '100%';
        var externalUrl = url;
        var createIframe = document.createElement('iframe');
        createIframe.id = 'video__external';
        createIframe.src = externalUrl;
        createIframe.classList.add('video__iframe');
        this.playerContent.appendChild(createIframe);
    };
    return HeaderBannerVideo;
}(Base));
export { HeaderBannerVideo };



//////////////////
// WEBPACK FOOTER
// ./components/header-banner-video/header-banner-video.component.ts
// module id = 349
// module chunks = 0